import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _includesInstanceProperty from "@babel/runtime-corejs3/core-js/instance/includes";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Badge from "@Shared/components/general/badge.vue";
import { getRequestPackageBadgeType } from "@Shared/@Utils/utils";
import { mapActions } from "vuex";
import { RESET_SECURE_DETAILS } from "@Broker/@Modules/clients/applications/documents/store/documents-actions";
import TimelineConsolidatedRequest from "@Broker/@Modules/clients/board/client-profile/components/timeline/timeline-client-application-request/timeline-consolidated-request.vue";
import SimpleButton from "@Shared/components/buttons/simple-button.vue";
import MaterialInput from "@Shared/components/inputs/material-input.vue";
import ApplicantSelect from "@Broker/@Modules/util-components/application/applicant-select.vue";
import { differenceBy, isEmpty, remove } from "lodash";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "PreviousRequestedPackagesStep",
  components: {
    Badge,
    TimelineConsolidatedRequest,
    SimpleButton,
    MaterialInput,
    ApplicantSelect
  },
  props: {
    previousRequestedPackages: {
      type: Array,
      required: true
    },
    applicants: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      columns: ["status", "createdAt", "actions"],
      openedChildRows: [],
      requestedPackagesToShowResetPin: [],
      selectedApplicant: {},
      loadingResetPin: ""
    };
  },
  computed: {
    options() {
      return {
        uniqueKey: "requestId",
        filterable: false,
        sortable: [],
        headings: {
          select: "",
          status: this.$t("global.words.status"),
          createdAt: this.$t("global.words.date"),
          actions: this.$t("global.words.actions")
        },
        columnsClasses: {
          actions: "d-flex flex-row justify-content-end"
        },
        skin: "table mb-0",
        perPage: 999999,
        showChildRowToggler: false
      };
    }
  },
  mounted() {
    this.$emit("valid", true);
    this.openedChildRows = [];
    this.requestedPackagesToShowResetPin = [];
  },
  methods: _objectSpread(_objectSpread({}, mapActions("DocumentsStore", [RESET_SECURE_DETAILS])), {}, {
    getBadgeType(status) {
      return getRequestPackageBadgeType(status);
    },
    togglePackage({
      requestId
    }, resetPin = false) {
      return resetPin ? this.handleToggleResetPin(requestId) : this.handleToggleViewDetails(requestId);
    },
    canResetPin({
      metadata
    }) {
      var _metadata$bankStateme;
      const hasDocumentsRequest = !isEmpty(metadata.documentRequestIds);
      const hasBankStatementRequest = !isEmpty((_metadata$bankStateme = metadata.bankStatements) == null ? void 0 : _metadata$bankStateme.emails);
      const hasApplicationShared = metadata.shared || !(hasBankStatementRequest || hasDocumentsRequest);
      const hasCoApplicants = !isEmpty(metadata.coApplicants);
      return hasDocumentsRequest || hasApplicationShared && hasCoApplicants;
    },
    showResetPin(requestId) {
      var _context;
      return _includesInstanceProperty(_context = this.requestedPackagesToShowResetPin).call(_context, requestId);
    },
    async handleResetPin({
      requestId
    }) {
      var _this$selectedApplica;
      this.loadingResetPin = requestId;
      await this.RESET_SECURE_DETAILS({
        applicationId: this.$route.params.applicationId,
        clientUsername: this.$route.params.clientUsername,
        coApplicantId: ((_this$selectedApplica = this.selectedApplicant[requestId]) == null ? void 0 : _this$selectedApplica.applicantId) || null,
        requestId
      });
      this.loadingResetPin = null;
      this.selectedApplicant[requestId] = null;
    },
    handleToggleViewDetails(requestId) {
      var _context2;
      const isOpened = _includesInstanceProperty(_context2 = this.openedChildRows).call(_context2, requestId);
      if (this.showResetPin(requestId)) {
        var _context3;
        this.requestedPackagesToShowResetPin = _filterInstanceProperty(_context3 = this.requestedPackagesToShowResetPin).call(_context3, itemRequestId => itemRequestId !== requestId);
        return;
      }
      if (isOpened) {
        remove(this.openedChildRows, itemRequestId => itemRequestId === requestId);
      } else {
        this.openedChildRows.push(requestId);
      }
      this.$refs.requestedPackagesTable.toggleChildRow(requestId);
    },
    handleToggleResetPin(requestId) {
      var _context4;
      const isOpened = _includesInstanceProperty(_context4 = this.openedChildRows).call(_context4, requestId);
      if (!this.showResetPin(requestId)) {
        this.requestedPackagesToShowResetPin.push(requestId);
        if (!isOpened) this.openedChildRows.push(requestId);else return; // this way we prevent the child row to toggle
      } else {
        remove(this.requestedPackagesToShowResetPin, itemRequestId => itemRequestId === requestId);
        remove(this.openedChildRows, itemRequestId => itemRequestId === requestId);
      }
      this.$refs.requestedPackagesTable.toggleChildRow(requestId);
    },
    getApplicantsToExclude({
      metadata
    }) {
      var _context5, _metadata$bankStateme2, _context6, _metadata$coApplicant;
      const onlyMainApplicantRequested = isEmpty(metadata.coApplicants);
      if (onlyMainApplicantRequested) return _filterInstanceProperty(_context5 = this.applicants).call(_context5, ({
        applicantIndex
      }) => applicantIndex !== 0);
      const hasDocumentsRequest = !isEmpty(metadata.documentRequestIds);
      const hasBankStatementRequest = !isEmpty((_metadata$bankStateme2 = metadata.bankStatements) == null ? void 0 : _metadata$bankStateme2.emails);
      const hasApplicationShared = metadata.shared || !(hasBankStatementRequest || hasDocumentsRequest);

      // Exclude main applicant if only application has been shared
      const excludeMainApplicant = !hasDocumentsRequest && !hasBankStatementRequest && hasApplicationShared;
      const nonSelectedCoApplicants = differenceBy(_filterInstanceProperty(_context6 = this.applicants).call(_context6, ({
        applicantIndex
      }) => applicantIndex !== 0), metadata.coApplicants, "applicantIndex");
      const coApplicantsToExclude = ((_metadata$coApplicant = metadata.coApplicants) == null ? void 0 : _filterInstanceProperty(_metadata$coApplicant).call(_metadata$coApplicant, applicant => isEmpty(applicant.documentRequestIds) && isEmpty(applicant.fillOut))) || [];
      return excludeMainApplicant ? [...coApplicantsToExclude, ...nonSelectedCoApplicants, {
        applicantIndex: 0
      }] : [...coApplicantsToExclude, ...nonSelectedCoApplicants];
    },
    getButtonIcon({
      requestId
    }, resetPin = false) {
      var _context7, _context8;
      const resetPinShown = _includesInstanceProperty(_context7 = this.requestedPackagesToShowResetPin).call(_context7, requestId);
      if (resetPin) return resetPinShown ? "caret-up" : "caret-down";
      const isOpen = _includesInstanceProperty(_context8 = this.openedChildRows).call(_context8, requestId);
      return isOpen && !resetPinShown ? "caret-up" : "caret-down";
    },
    getBadgeMessage(row) {
      const isMainApplicantPending = row.metadata.status === "pending";
      const areCoApplicantsPending = !isEmpty(row.metadata.coApplicants) && row.metadata.coApplicants.every(({
        status
      }) => status === "pending");
      return areCoApplicantsPending || isMainApplicantPending ? this.$t("application.status.pending").toLowerCase() : this.$t("global.words.completed").toLowerCase();
    }
  })
});